<template>
  <div class="IOArchiveDetails">
    <v-dialog v-model="visible">
      <box :title="$t('ioDetails')">
        <v-row class="pa-2">
          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("PageNo") }}:</v-col>
              <v-col>
                <span class="text-value">{{ item.Id }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("RequestedPersonName") }}:</v-col>
              <v-col>
                <span class="text-value">{{ details.personName }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("RequestDate") }}:</v-col>
              <v-col>
                <span class="text-value">{{ item.RequestDate }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("RequestTime") }}:</v-col>
              <v-col>
                <span class="text-value">{{ item.RequestTime }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("date") }}:</v-col>
              <v-col>
                <span class="text-value">{{ item.ClockDate }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("time") }}:</v-col>
              <v-col>
                <span class="text-value">{{ item.ClockTime }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("requestType") }}:</v-col>
              <v-col>
                <span class="text-value">{{ item.Io }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("LastChangeDate") }}:</v-col>
              <v-col>
                <span class="text-value">{{ details.lastChangeDate }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("status") }}:</v-col>
              <v-col>
                <span
                  class="text-value"
                  v-text="
                    item.StatusType +
                    '-' +
                    (details.isTransfer
                      ? 'انتقال داده شده'
                      : 'انتقال داده نشده')
                  "
                ></span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="6">
            <v-row>
              <v-col>{{ $t("ApprovedPerson") }}:</v-col>
              <v-col>
                <span class="text-value">{{ ApprovedPerson }}</span>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row>
              <v-col cols="3">{{ $t("description") }}:</v-col>
              <v-col cols="9">
                <span class="text-value">
                  درخواست دهنده:{{ details.userDescription }} <br />
                  <span>تائید / رد کننده: {{ details.adminDescription }}</span>
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small v-if="visibleEdit" @click="editItem">{{
            $t("edit")
          }}</v-btn>
          <v-btn small v-if="visibleDelete" @click="deleteItem">{{
            $t("delete")
          }}</v-btn>
        </v-card-actions>

        <archive-detals-flow
          v-if="showWorkFlow"
          :pageNo="`${item.Id}`"
          :pageType="3"
          :year="Number(item.Year)"
        />
      </box>
    </v-dialog>
  </div>
</template>

<script>
import ArchiveDetalsFlow from "./ArchiveDetalsFlow.vue";
import RequestState from "../../model/RequestState";
import TextUtils from "../../utils/TextUtils";
import ResultType from "../../model/ResultType";
import DateUtils from "../../utils/DateUtils";

const initialData = () => {
  return {
    showWorkFlow: false,
    visible: false,
    item: "",
    details: "",
    visibleEdit: false,
    visibleDelete: false,
    ApprovedPerson: "",
  };
};

export default {
  components: { ArchiveDetalsFlow },
  props: {},
  data() {
    return initialData();
  },
  methods: {
    resetData() {
      Object.assign(this.$data, initialData());
    },
    show(item) {
      this.resetData();
      this.visible = true;
      item.Year = TextUtils.convertToEnglishDigits(item.ClockDate.substr(0, 4));
      this.item = item;
      this.GetIoDetail(item);
    },
    hide() {
      this.visible = false;
    },
    GetIoDetail(item) {
      console.log(item);
      const params = new URLSearchParams();
      params.append("id", TextUtils.convertToEnglishDigits(item.Id));
      params.append("year", item.Year);

      var GetIoDetailForArchiveParams = {
        perno: item.Perno,
        date: DateUtils.removeYearFromDate(
          TextUtils.convertToEnglishDigits(item.ClockDate)
        ),
        time: TextUtils.convertToEnglishDigits(item.ClockTime),
        iotype: item.Io_Type,
        dbkind: item.DBKind,
        status: item.Status,
        year: item.Year,
      };

      this.$store
        .dispatch("GetIoDetailForArchive", { GetIoDetailForArchiveParams })
        .then((result) => {
          //console.log(result);
          if (result.type == "success") {
            if (result.data.length > 0) {
              this.details = result.data[0];

              //console.log(this.details.isTransfer, item);
              if (!this.details.isTransfer && item.DBKind == 1) {
                this.showWorkFlow = true;
              } else {
                this.showWorkFlow = false;
              }

              this.checkActionsVisiblity();
              this.getApprovedPerson();
            }
          }
        });
    },
    getApprovedPerson() {
      if (this.details.approvedBy.trim() == "-1") {
        this.ApprovedPerson = this.$t("webkartManager");
      } else if (this.details.approvedBy.trim() == "000") {
        this.ApprovedPerson = this.$t("winkartManager");
      } else {
        let params = new URLSearchParams();
        params.append("perno", this.details.approvedBy.trim());
        this.$store.dispatch("GetPersonFullName", { params }).then((result) => {
          if (result.type === ResultType.success) {
            this.ApprovedPerson = result.data;
          }
        });
      }
    },
    checkActionsVisiblity() {
      ////console.log(String.fromCharCode(1740));
      ////console.log(String.fromCharCode(1610));
      this.visibleEdit = false;
      this.visibleDelete = false;

      switch (this.item.Status) {
        case 0: //darkhost avaliyeh
        case 1: //bargasht khordeh
        case 2: //ersal mojadad
        case 4: //rad shodeh
          //btnPrint.Visible = false;
          // this.visibleEdit = this.item.Status != 1;
          this.visibleEdit=true;

          if (this.item.Status == 1) {
            this.visibleEdit=false;

            //emkan hazfe darkhoste rad shodeh
            this.visibleDelete =
              this.$store.state.personel.personelDetail.Permission[15].toString() ==
              "1";
          } else {
            this.visibleDelete = true;
          }
      }
    },
    editItem() {
      console.log(this.item);
      console.log(this.details);
      this.visible = false;
      let details = {
        PageNo: this.item.Id.toString().trim(),
        Year: this.item.Year,
        DBKind: this.item.DBKind,
        selectedPerno: this.item.Perno,
        from: "request-io-archive",
      };

      this.details["Year"] = this.item.Year;
      this.$router.push({
        name: "request-io",
        params: { details: details },
      });
    },
    deleteItem() {
      var params = [
        {
          PageNo: this.item.Id,
          Year: this.item.Year,
          AdminPerno: this.item.Perno.trim(),
          RequestState: RequestState.RequestState.Delete,
          ReasonOfAdmin: "",
          Status: "",
        },
      ];

      this.$store
        .dispatch("OprationOnInOutArchive", { params })
        .then((result) => {
          ////console.log(result);
          if (result.type === "success") {
            this.$emit("refresh");
          }
        });
    },
  },
};
</script>

<style>
</style>